import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { PersonTypeEnum } from "../services/enums.js";

Vue.use(Vuex);
/*
Ver documentación en: https://vuex.vuejs.org/api/#mutations
*/

const PersonsVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Persons", //Persons en el mock
    $_moduleApiPapirusPath: "v1.0/PapirusPersons", //Persons en el mock
    $_persons: [],
    $_clients: [],
    $_brokers: [],
    $_thirdParties: [],
    $_agents: [],
    $_exclusivities: [],
    $_currentPerson: {},
    $_currentExclusivity: {},
    $_errorState: {},
    $_actionState: {
      message: null,
      status: 200,
      data: {}
    }
  }),
  getters: {
    allPersons: (state) => state.$_persons,
    allClients: (state) => state.$_clients,
    allBrokers: (state) => state.$_brokers,
    allThirdParties: (state) => state.$_thirdParties,
    allAgents: (state) => state.$_agents,
    allExclusivities: (state) => state.$_exclusivities,
    currentPerson: (state) => state.$_currentPerson,
    currentExclusivity: (state) => state.$_currentExclusivity,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initPerson({ commit }) {
      var person = {
        id: 0,
        givenName: null,
        otherGivenNames: null,
        familyName: null,
        otherFamilyNames: null,
        businessName: null,
        documentType: null,
        documentNumber: null,
        phoneNumber: null,
        email: null,
        personType: null,
        currentThirdPersonType: null,
        clientData: {
          id: 0,
          personId: null,
          isActive: false
        },
        agentData: {
          id: 0,
          agentType: null,
          localCode: null,
          personId: null,
          brokerId: null,
          isActive: false
        },
        brokerData: {
          id: 0,
          localCode: null,
          personId: null,
          branchOfficeId: null,
          isActive: false
        },
        thirdData: {
          id: 0,
          localCode: null,
          personId: null,
          thirdPartyType: null,
          isActive: false
        },
        personUser: {
          id: 0,
          personId: null,
          userId: null,
          isActive: false
        },
        thirdPersonTypes: []
      };

      commit("SET_PERSON", person);
    },
    clearPersons({ commit }) {
      commit("SET_PERSONS", []);
    },
    setPerson({ commit }, person) {
      commit("SET_PERSON", person);
    },
    async getPersons(
      { commit, dispatch, state, rootGetters },
      thirdPersonType
    ) {
      var baseUrl = rootGetters.baseUrl;
      //var actionLink = baseUrl + state.$_moduleApiPath + "/" + thirdPersonType;
      var actionLink =
        baseUrl + state.$_moduleApiPath + "/bytype/" + thirdPersonType;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);

        switch (thirdPersonType) {
          case PersonTypeEnum.CLIENTS.id:
            commit("SET_CLIENTS", response.data);
            break;
          case PersonTypeEnum.AGENTS.id:
            commit("SET_AGENTS", response.data);
            break;
          case PersonTypeEnum.BROKERS.id:
            commit("SET_BROKERS", response.data);
            break;
          case PersonTypeEnum.THIRDPARTIES.id:
            commit("SET_THIRDPARTIES", response.data);
            break;
          default:
            commit("SET_PERSONS", response.data);
            break;
        }
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getRestrictiveList(
      { rootGetters },
      { documentType, documentNumber, fullName }
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + "v1.0/RestrictiveList";
      var axiosConfig = rootGetters.axiosConfig;
      var appId = rootGetters.applicationId;

      var request = {
        idAplicativo: appId,
        idTipoDocumento: parseInt(documentType),
        nombreCompleto: fullName,
        numeroDocumento: documentNumber
      };

      try {
        const response = await axios.post(actionLink, request, axiosConfig);
        return response.data;
      } catch (error) {
        return null;
      }

      /*
        {
          "idAplicativo": 1,
          "idTipoDocumento": 1,
          "nombreCompleto": "GLADYS GONZALEZ TORO",
          "numeroDocumento": "24571987"
        }      
      */
    },
    async getPersonsForGrid(
      { commit, dispatch, state, rootGetters },
      thirdPersonType
    ) {
      var baseUrl = rootGetters.baseUrl;
      //var actionLink = baseUrl + state.$_moduleApiPath + "/" + thirdPersonType;
      var actionLink =
        baseUrl + state.$_moduleApiPapirusPath + "/bytype/" + thirdPersonType;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PERSONS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getPersonsByDynamicSearch(
      { commit, dispatch, state, rootGetters },
      data
    ) {
      var baseUrl = rootGetters.baseUrl;
      //var actionLink = baseUrl + state.$_moduleApiPath + "/" + thirdPersonType;
      var actionLink =
        baseUrl +
        state.$_moduleApiPapirusPath +
        "/byDynamicSearch/" +
        data.searchTypeId +
        "/" +
        data.searchValue +
        "/" +
        data.thirdPersonType;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PERSONS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getPerson({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      //var actionLink = baseUrl + state.$_moduleApiPath + "/GetPerson/" + id;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PERSON", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getExclusivities({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      //var actionLink = baseUrl + state.$_moduleApiPath + "/GetPerson/" + id;
      var actionLink =
        baseUrl +
        state.$_moduleApiPapirusPath +
        "/Exclusivities/" +
        data.id +
        "/" +
        data.type;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_EXCLUSIVITIES", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getExclusivity({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      //var actionLink = baseUrl + state.$_moduleApiPath + "/GetPerson/" + id;
      var actionLink =
        baseUrl +
        state.$_moduleApiPapirusnPath +
        "/Exclusivity/" +
        data.id +
        "/" +
        data.user;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_EXCLUSIVITY", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getPersonByDocument({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl +
        state.$_moduleApiPath +
        "/ByDocument/" +
        data.documentType +
        "/" +
        data.documentNumber;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        if (!response.data) {
          dispatch("initPerson");
        } else {
          commit("SET_PERSON", response.data);
        }
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async createPerson({ commit, dispatch, state, rootGetters }, person) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.post(actionLink, person, axiosConfig);
        person.id = response.data.id;
        commit("SET_PERSON", person);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async saveExclusivity(
      { commit, dispatch, state, rootGetters },
      exclusivity
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPapirusPath + "/Exclusivity";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.post(actionLink, exclusivity, axiosConfig);
        exclusivity.id = response.data.id;
        commit("SET_PERSON", exclusivity);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async updatePerson({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data.person, axiosConfig);
        data.person.id = response.data.id;

        commit("SET_PERSON", data.person);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async inactivePerson({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl +
        state.$_moduleApiPath +
        "/InactiveThirdPersonType/" +
        data.id +
        "/" +
        data.thirdPersonType;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        await axios.put(actionLink, data, axiosConfig);
        // commit("SET_PERSON", data.person);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_CLIENTS(state, value) {
      state.$_clients = value;
    },
    SET_BROKERS(state, value) {
      state.$_brokers = value;
    },
    SET_THIRDPARTIES(state, value) {
      state.$_thirdParties = value;
    },
    SET_AGENTS(state, value) {
      state.$_agents = value;
    },

    SET_PERSONS(state, value) {
      state.$_persons = value;
    },
    SET_PERSON(state, value) {
      state.$_currentPerson = value;
    },
    SET_EXCLUSIVITIES(state, value) {
      state.$_exclusivities = value;
    },
    SET_EXCLUSIVITY(state, value) {
      state.$_currentExclusivity = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default PersonsVuexModule;
